
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component
export default class DonationFormSection extends Vue {
  @Prop({ type: String, required: true }) title!: string
  @Prop() orgaColor!: string
}
